import { FormErrorMessages } from '../views/shared/components/form-components/form-error/form-error-messages';

export class FormValidationUtils {
  public static readonly INVALID_DATE_MARKER = '__INVALID_DATE__';

  public static readonly DEFAULT_FORM_ERROR_MESSAGES: FormErrorMessages = {
    required: $localize`Entry is required`,
    email: $localize`Invalid email address`,
    invalidPhoneNumber: $localize`Invalid phone number`,
    invalidDate: $localize`Invalid date`,
    invalidEmail: $localize`Invalid email address`,
    dateInFuture: $localize`Date cannot be in the future`,
    dateInPast: $localize`Date cannot be in the past`,
    dateRangeInvalid: $localize`End date must be later than start date`,
    passwordRequiresUppercase: $localize`Password must contain an upper case character`,
    passwordRequiresLowercase: $localize`Password must contain a lower case character`,
    passwordRequiresNumber: $localize`Password must contain a number`,
    passwordRequiresSymbol: $localize`Password must contain a special character`,
    passwordsMustMatch: $localize`Passwords must match`,
    invalidSin: $localize`Invalid social insurance number`,
    emailsMustMatch: $localize`Emails must match`
  };
}
